module.exports = __webpack_public_path__ + "img/cross-resonance-line-short.59359e82.svg";